import instance, { ADMIN_PREFIX } from 'services/api';

export interface DoctorReviewPeer {
  id: number;
  first_name: string;
  last_name: string;
  email: string | null;
}

export interface DoctorReviewRow {
  id: number;
  rating: number;
  review: string | null;
  created_at: string;
  sender: DoctorReviewPeer | null;
  receiver: DoctorReviewPeer | null;
}

export interface DoctorReviewsResponse {
  data: DoctorReviewRow[];
  total: number;
}

export interface CallReviewSender {
  id: number;
  first_name: string;
  last_name: string;
  email: string | null;
}

export interface CallReviewRow {
  id: number;
  appointment_id: number;
  review: string | null;
  satisfied: boolean | null;
  issues: string[] | null;
  created_at: string;
  sender: CallReviewSender | null;
}

export interface CallReviewsResponse {
  data: CallReviewRow[];
  total: number;
}

export interface FetchReviewsParams {
  page: number;
  limit: number;
}

export const fetchDoctorReviews = (params: FetchReviewsParams) =>
  instance.get<DoctorReviewsResponse>(`${ADMIN_PREFIX}/reviews`, { params });

export const fetchCallReviews = (params: FetchReviewsParams) =>
  instance.get<CallReviewsResponse>(`${ADMIN_PREFIX}/call-reviews`, {
    params
  });
